// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';

// Types
type $Props = $Translate & {
  item: $Model<'ChampionshipAdminRequest'> | $ModelUpsertParams<'ChampionshipAdminRequest'>;
};

const ChampionshipAdminRequestFieldsView = function ({
  item,
  t,
}: $Props) {
  return (
    <Row>
      <Col>
        <AvField
          label={t('Name')}
          name={'Name'}
          value={item.Name}
        />
      </Col>
      <Col>
        <AvField
          label={t('Email')}
          name={'Email'}
          required
          type={'email'}
          value={item.Email}
        />
      </Col>
    </Row>
  );
};

export default ChampionshipAdminRequestFieldsView;
